function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { Animated, Easing, Platform } from 'react-native';
import { RTLService } from "../../devsupport";
export class TabIndicator extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "indicatorWidth", void 0);

    _defineProperty(this, "contentOffset", new Animated.Value(0));

    _defineProperty(this, "onContentOffsetAnimationStateChanged", state => {// no-op
    });

    _defineProperty(this, "onContentOffsetAnimationStateEnd", result => {// no-op
    });

    _defineProperty(this, "createOffsetAnimation", params => {
      return Animated.timing(this.contentOffset, {
        toValue: RTLService.select(params.offset, -params.offset),
        duration: 200,
        easing: Easing.linear,
        useNativeDriver: Platform.OS !== 'web'
      });
    });

    _defineProperty(this, "onLayout", event => {
      this.indicatorWidth = event.nativeEvent.layout.width;
      this.scrollToOffset({
        offset: this.indicatorWidth * this.props.selectedPosition,
        animated: false
      });
    });

    _defineProperty(this, "getComponentStyle", () => {
      const widthPercent = 100 / this.props.positions;
      return {
        width: `${widthPercent}%`,
        // @ts-ignore: RN has no types for `Animated` styles
        transform: [{
          translateX: this.contentOffset
        }]
      };
    });
  }

  componentDidMount() {
    this.contentOffset.addListener(this.onContentOffsetAnimationStateChanged);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.selectedPosition !== nextProps.selectedPosition;
  }

  componentDidUpdate() {
    const {
      selectedPosition: index
    } = this.props;
    this.scrollToIndex({
      index,
      animated: true
    });
  }

  componentWillUnmount() {
    this.contentOffset.removeAllListeners();
  }
  /**
   * scrolls indicator to passed index
   *
   * @param params (object) - {
   *  index: number,
   *  animated: boolean | undefined
   * }
   */


  scrollToIndex(params) {
    const {
      index
    } = params,
          rest = _objectWithoutProperties(params, ["index"]);

    const offset = this.indicatorWidth * index;
    this.scrollToOffset(_objectSpread({
      offset
    }, rest));
  }
  /**
   * scrolls indicator to passed offset
   *
   * @param params (object) - {
   *  offset: number,
   *  animated: boolean | undefined
   * }
   */


  scrollToOffset(params) {
    this.createOffsetAnimation(params).start(this.onContentOffsetAnimationStateEnd);
  }

  render() {
    const _this$props = this.props,
          {
      style
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["style"]);

    const evaStyle = this.getComponentStyle();
    return /*#__PURE__*/React.createElement(Animated.View, _extends({}, viewProps, {
      style: [style, evaStyle],
      onLayout: this.onLayout
    }));
  }

}

_defineProperty(TabIndicator, "defaultProps", {
  selectedPosition: 0
});